/* Bambova: paket kartı seçimini Dawn varyant değişimiyle eşitler; kapıda ödeme butonu ürünü ekleyip ödeme adımına götürür. */
(() => {
  const sync = (root = document) => {
    root.querySelectorAll('[data-bv-bundles]').forEach((box) => {
      const pos = box.dataset.pos;
      const picker = document.getElementById('variant-selects-' + box.dataset.section);
      const checked = picker && picker.querySelector(`fieldset:nth-of-type(${pos}) input:checked`);
      box.querySelectorAll('.bv-bundle').forEach((card) => card.classList.toggle('is-active', !!checked && card.htmlFor === checked.id));
    });
  };
  document.addEventListener('change', () => requestAnimationFrame(() => sync()));
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.variantChange, () => sync());

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bv-cod]');
    if (!btn) return;
    const form = document.getElementById(btn.dataset.form);
    const id = form && form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +id.value, quantity: 1 }] }) });
      if (!res.ok) throw new Error((await res.json()).description || 'Sepete eklenemedi');
      location.href = '/checkout';
    } catch (err) {
      alert(err.message);
      btn.disabled = false;
    }
  });
})();
